// Public-website configuration (review fix F11).

export interface PublicContact {
  /** A monitored support mailbox, e.g. "support@omnistspirituality.com" -- only once it exists. */
  supportEmail: string;
  /** Optional help-center or contact-form URL. */
  supportUrl: string;
  /** The legal entity that operates Omnist, exactly as registered. */
  legalEntityName: string;
  /** Postal address for legal notices, if one will be published. */
  postalAddress: string;
}

/**
 * PUBLIC_CONTACT is the single place for Omnist's published contact and legal-identity details.
 *
 * Every field is intentionally EMPTY: no support mailbox, legal entity or address has been
 * confirmed, and none may be invented. While a field is empty, the Support, Privacy and Terms
 * pages and the footer render a plain "not published yet" state instead. Fill these in (Mauro)
 * before launch -- nothing else needs to change.
 */
export const PUBLIC_CONTACT: PublicContact = {
  supportEmail: '',
  supportUrl: '',
  legalEntityName: '',
  postalAddress: '',
};

export const SITE = {
  name: 'Omnist',
  /** Canonical origin -- the apex domain redirects here (see docs/CUSTOM_DOMAIN.md). */
  canonicalOrigin: 'https://www.omnistspirituality.com',
  /** When the plain-language Privacy/Terms drafts were written; shown on those pages. */
  legalDraftDate: '2026-09-10',
} as const;
